import _ from 'lodash';

export default (products: any) => {
  _.each(products, product => {
    const tags = { uiGroup: undefined };
    _.each(product.tags, tag => {
      const parts = tag.split(':');
      if (parts.length < 2) {
        console.warn('Invalid tag on product', tag);
        return;
      }
      // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
      tags[parts[0]] = parts[1];
    });
    tags.uiGroup = tags.uiGroup || product.id;
    product.tags = tags;
  });
};
